export const downloadFile = (blob, fileName) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    URL.revokeObjectURL(url);
    link.remove();
  }, 100);
};

export const printFromResponse = async (blob, fileName, copies) => {
  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  const base64 = dataUrl.split(',')[1];

  window.nativePrint?.print({
    fileBase64: base64,
    fileName: fileName || 'nyomtatas.pdf',
    copies: copies || 1,
  });
};
